<div class="comment-msg-p">

  <i class="table-material-icons">warning</i>
  You have chosen to submit a group report, but you have not included 
  any companies in the group. Please include at least one company in the group
  before submitting the report.
</div>